import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_LOCUS = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_LOCUS' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-50'><span className='eleHeader'>&nbsp;</span></td>
                        <td className='w-400'><span className='eleHeader'>DIMENSIONS</span></td>
                        <td className='w-150'><span className='eleHeader'>CURRENT</span></td>
                        <td className='w-150'><span className='eleHeader'>CRITERIA</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'>I</td>
                        <td className='w-400'>Risk of Harm <br />
                            <input type='text' id='txtRoh_Info' name='txtRoh_Info' className='add-only' />
                        </td>
                        <td className='w-150'><input type='text' id='txtRoh_Current' name='txtRoh_Current' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtRoh_Criteria' name='txtRoh_Criteria' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-50'>II</td>
                        <td className='w-400'>Functional Status <br />
                            <input type='text' id='txtFs_Info' name='txtFs_Info' className='add-only' />
                        </td>
                        <td className='w-150'><input type='text' id='txtFs_Current' name='txtFs_Current' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtFs_Criteria' name='txtFs_Criteria' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-50'>III</td>
                        <td className='w-400'>Medical, Addictive, Psychiatric Co-Morbidity <br />
                             <input type='text' id='txtMap_Info' name='txtMap_Info' className='add-only' />
                        </td>
                        <td className='w-150'><input type='text' id='txtMap_Current' name='txtMap_Current' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMap_Criteria' name='txtMap_Criteria' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-50'>IV-A</td>
                        <td className='w-400'>Recovery Environment (Stress) <br />
                             <input type='text' id='txtReStress_Info' name='txtReStress_Info' className='add-only' />
                        </td>
                        <td className='w-150'><input type='text' id='txtReStress_Current' name='txtReStress_Current' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtReStress_Criteria' name='txtReStress_Criteria' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-50'>IV-B</td>
                        <td className='w-400'>Recovery Environment (Support) <br />
                            <input type='text' id='txtReSupport_Info' name='txtReSupport_Info' className='add-only' />
                        </td>
                        <td className='w-150'><input type='text' id='txtReSupport_Current' name='txtReSupport_Current' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtReSupport_Criteria' name='txtReSupport_Criteria' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-50'>V</td>
                        <td className='w-400'>Resiliency and Treatment <br />
                            <input type='text' id='txtRt_Info' name='txtRt_Info' className='add-only' />
                        </td>
                        <td className='w-150'><input type='text' id='txtRt_Current' name='txtRt_Current' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtRt_Criteria' name='txtRt_Criteria' className='add-only' /></td>
                    </tr>
                    
                    <tr>
                        <td className='w-50'>VI</td>
                        <td className='w-400'>Engagement <br />
                            <input type='text' id='txtEng_Info' name='txtEng_Info' className='add-only' />
                        </td>
                        <td className='w-150'><input type='text' id='txtEng_Current' name='txtEng_Current' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtEng_Criteria' name='txtEng_Criteria' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-450'>Level of Care Recommended</td>
                        <td className='w-300'><input type='text' id='txtCompScore' name='txtCompScore' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-450'>Composite Score</td>
                        <td className='w-300'><input type='text' id='txtLoc' name='txtLoc' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-290'></td>
                        <td className='signature w-290'></td>
                        <td className='signature w-140'></td>
                    </tr>
                    <tr>
                        <td className='small w-290'> LMHP Printed Name </td>
                        <td className='small w-290'> LMHP Signature </td>
                        <td className='small w-140'> Date </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











